import { FC } from 'react';
import styles from './HeaderDivider.module.scss';

export const HeaderDivider: FC = () => {
  return <div className={styles['divider']} />;
};
